import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {FormGroup} from '@angular/forms';
import {Item} from '../../item';
import {ConnecttocrudService} from '../../connecttocrud.service';
import {ActivatedRoute} from '@angular/router';
import {Location} from '@angular/common';
import {ConfService} from '../../conf.service';
import {AppComponent} from '../../app.component';
import {LeftpanelComponent, LoaderWithProgressComponent} from '../../leftpanel/leftpanel.component';
import {MatDialog} from '@angular/material';
import { saveAs } from 'file-saver';

@Component({
    selector: 'app-import',
    templateUrl: './import.component.html',
    styleUrls: ['./import.component.css']
})
export class ImportComponent implements OnInit {
    itemname: string;
    csvData: any[] = [];
    form: FormGroup;
    columns: string[];
    partner: string;
    account: string;
    entity: string;
    version: string;
    partnerKey: string;
    dataSource: any;
    dataModel: any;
    items: Item[] = new Array();
    constructor(private _http: HttpClient,
                private _service: ConnecttocrudService,
                private route: ActivatedRoute,
                private location: Location,
                private appComp: AppComponent,
                public platform: LeftpanelComponent, public dialog: MatDialog,
                private confPost: ConfService) {  /*this.setcolumnvalues();*/ }

    ngOnInit() {
        this.appComp.currentPageTitle = 'Import Data';
        this.route.queryParams
            .subscribe(params => {
                this.partner = params.partner;
                this.account = params.account;
                this.entity = params.entity;
                this.version = params.version;
                this.partnerKey = localStorage.getItem('partnerKey');
               // this.items = null;
                this.setcolumnvalues();
            });
    }
    saveChanges() {
        // const blob = new Blob([JSON.stringify(this.items)], {type : 'application/json'});
        // saveAs(blob, 'data.json');
        const loaderDialog = this.dialog.open(LoaderWithProgressComponent, {
            maxWidth: '95vw',
            maxHeight: '60vh',
        });
        this._service.saveItems(this.version, this.partner, this.account, this.entity, this.items).subscribe(
            status => {
                loaderDialog.close();
                this.platform.openSnackBar('Data imported successfully', 'Success', {
                    duration: 3000,
                    verticalPosition: 'top',
                    horizontalPosition: 'center'
                });
            },
            error => {
                loaderDialog.close();
                this.platform.handleErrorGracefully(error, 'Error while saving item. Please try after sometime.');
            }
        );
    }

    public changeListener(files: FileList) {
        if (files && files.length > 0) {
            let file : File = files.item(0);
            let reader: FileReader = new FileReader();
            reader.readAsText(file);
            reader.onload = (e) => {
                let csv: any = reader.result;
                this.csvtoJson(csv.split('\r'));
            };
        }
    }
    public setcolumnvalues() {
        this.columns = [];
        this.confPost.getPartnerEntity(this.account, this.entity, this.partner).subscribe(items => {
            this.dataSource = items[0].attributes;
            this.getDataModel();
            for (const itemval in this.dataModel) {
                this.columns.push(itemval);
            }
        }, error => {
            this.platform.handleErrorGracefully(error, 'Error while retrieving entity. Please try after sometime.');
        });
       /* this._service.getItems(this.version, this.partner, this.account, this.entity).subscribe(
            items => {
                const itemunit = items[0];
                this.columns = [];
                for (const itemval in itemunit) {
                    this.columns.push(itemval);
                }
            },
            error => {
            }
        );*/
    }
    public csvtoJson(csv: any[]) {

        csv.forEach(element => {
            let elements = element.split(',');
            let item: Item = new Item();
            let i = 0;
            this.columns.forEach(column => {
                if (column && elements[i]) {
                    item[column] = elements[i].replace(/[\t\n]+/g, ' ');
                    i++;
                }
            });
            this.items.push(item);

        });
    }
    getDataModel() {
        this.dataModel = {};
        const that = this;
        this.dataSource.forEach((data) => {
            if (data.type != 'Array') {
                this.dataModel[data.attributeName] = data.type;
            } else {
                this.dataModel[data.attributeName] = (that.getSub(data.subType).length > 0 ? that.getSub(data.subType) : []);
            }
        });
        return this.dataModel;
    }

    getSub(data) {
        const subType = [];
        const obj = {};
        const that = this;
        if (data.length > 0) {
            data.forEach((result) => {
                if (result.type != 'Array') {
                    obj[result.attributeName] = result.type;
                } else {
                    obj[result.attributeName] = (that.getSub(result.subType).length > 0 ? that.getSub(result.subType) : []);
                }
            });
            subType.push(obj);
        }
        return subType;
    }

}
